import { useEffect, useCallback } from 'react';
import { useSearchParams } from 'react-router';
import { useTranslation } from 'react-i18next';
import { usePageContext } from '@hero/web-context';
import { FleetPage as SharedFleetPage } from '@hero/web-components';
import type { FleetTab } from '@hero/web-components';

const DEFAULT_TAB: FleetTab = 'vehicles';

export default function FleetPage() {
  const { t } = useTranslation(['dashboard']);
  const { setPageName } = usePageContext();
  const [searchParams, setSearchParams] = useSearchParams();

  const tabParam = searchParams.get('tab');
  const activeTab: FleetTab =
    tabParam === 'drivers' ? 'drivers' : tabParam === 'vehicles' ? 'vehicles' : DEFAULT_TAB;

  const handleTabChange = useCallback(
    (tab: FleetTab) => {
      setSearchParams(
        prev => {
          const next = new URLSearchParams(prev);
          if (tab === DEFAULT_TAB) {
            next.delete('tab');
          } else {
            next.set('tab', tab);
          }
          return next;
        },
        { replace: true },
      );
    },
    [setSearchParams],
  );

  useEffect(() => {
    setPageName(t('dashboard:Fleet.title'));
  }, [setPageName, t]);

  return <SharedFleetPage activeTab={activeTab} onTabChange={handleTabChange} />;
}
